import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';
import { brandPrimary } from '../../../../web/styles/colors';
import { CssSelectors } from '../../../../web/styles/styles';
import { aidaBaseStyles } from '../../../styles/styles';

export const styleSheet = StyleSheet.create({
	ctaContainer: {
		...aidaBaseStyles.flexHorizontalCenter,
		padding: '20px 30px 30px',
		...CssSelectors.allChildren({
			marginRight: 10,
		}),
	},
	dealField: {
		':first-child': {
			paddingTop: 0,
		},
		':last-child': {
			paddingBottom: 0,
		},
		padding: '7px 0',
	},
	dealForm: {
		flexGrow: 1,
		overflow: 'auto',
		padding: '20px 30px 0',
		position: 'relative',
	},
	dealDrawerContent: {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		background: '#fff',
	},
	header: {
		display: 'flex',
		alignItems: 'center',
		minHeight: 60,
		padding: '0 30px',
		gap: THEME.spacing.sm,
	},
	headerTitle: {
		color: brandPrimary,
		fontSize: `1.25rem`,
	},
	hexContainer: {
		height: 42,
		position: 'relative',
		width: 42,
	},
	hex: {
		left: '50%',
		position: 'absolute',
		top: '50%',
		transform: 'translate(-50%, -50%)',
		height: '100%',
		width: '100%',
	},
	lion: {
		left: '50%',
		position: 'absolute',
		top: '50%',
		transform: 'translate(-50%, -50%)',
		height: '70%',
		width: '70%',
	},
});
